<template>
	 <Header></Header>
	  <div class="login">
	    <div class="login_banner">
	      <img src="../assets/img/about_banner.png" alt="">
			<div class="login_box">
				<div class="form-wrap">
					<div class="form-content">
						<h6>注册四川数字出版传媒有限公司平台账号</h6>
						<form @submit.prevent="onSubmit" class="login-form">
							<div class="form-item"> 
								<div class="input-wrap id-card">
									<span class="icon"></span>
									<input id="reg-idcard" type="text" v-model.trim="idCard" @blur="touchIdCard = true" placeholder="请输入身份证号" />
								</div>
								<p v-if="touchIdCard && idCardError" class="error">{{ idCardError }}</p>
							</div>

							<div class="form-item"> 
								<div class="input-wrap name">
									<span class="icon"></span>
									<input id="reg-name" type="text" v-model.trim="name" @blur="touchName = true" placeholder="请输入姓名" />
								</div>
								<p v-if="touchName && nameError" class="error">{{ nameError }}</p>
							</div>

							<div class="form-item"> 
								<div class="input-wrap lock">
									<span class="icon"></span>
									<input id="reg-password" type="password" v-model.trim="password" @blur="touchPassword = true" placeholder="请输入8-20位且包含数字和字母的密码" />
								</div>
								<p v-if="touchPassword && passwordError" class="error">{{ passwordError }}</p>
							</div>

							<div class="form-item"> 
								<div class="input-wrap lock">
									<span class="icon"></span>
									<input id="reg-confirm" type="password" v-model.trim="confirmPassword" @blur="touchConfirm = true" placeholder="请再次输入密码" />
								</div>
								<p v-if="touchConfirm && confirmPasswordError" class="error">{{ confirmPasswordError }}</p>
							</div>

							<div class=" agree" style="display: flex; margin: 20px 0;">
								<div class="agree-row" style="float: left;">
									<input type="checkbox" v-model="agree" /> 
								</div>
								<p >注册平台账号代表您同意平台<span @click="showAgreement()" style="color: blue;cursor: pointer;">《用户注册协议》</span><span style="color: blue;cursor: pointer;">《隐私协议》</span></p>
							</div>

							<p v-if="submitError" class="error">{{ submitError }}</p>
							<button class="submit-btn" type="submit" :disabled="!isFormValid || isSubmitting || !agree">{{ isSubmitting ? '注册中…' : '注册' }}</button>
						</form>
						<div class="register"><router-link to="/Login">已有账号，前往登录</router-link></div>
					</div>
				</div>
			</div>
	    </div>
	  </div>
	  
	  <el-dialog v-model="centerDialogVisible" title="四川数字出版传媒有限公司平台用户注册协议" width="80%" center :show-close="showclose" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true">
	    
	    一、总则<br/>
	    1. 协议的接受：本协议是您与四川数字出版传媒有限公司平台（以下简称“本平台”）之间关于您使用本平台服务的法律协议。您点击“同意”按钮并完成注册流程，即表示您已阅读、理解并同意遵守本协议的所有条款。 <br/>
	    2. 协议的变更：本平台有权根据需要随时修改本协议的条款。一旦本协议的内容发生变动，本平台将通过平台公告、您注册时提供的电子邮件地址等向您提示修改内容。如果您继续使用本平台的服务，即视为您已充分阅读、理解并同意接受修改后的协议内容。<br/>
	    <div class="hei20"></div>
	   二、用户注册<br/>
	   1. 注册资格：您必须是具备完全民事行为能力的自然人、法人或其他组织。<br/>
	   2. 注册信息：您必须提供真实、准确、有效的个人信息进行注册，包括但不限于姓名、身份证号码、联系方式等。您应保证所提供的个人信息是最新的，并在信息变更时及时更新。<br/>
	   3. 账户安全：您应妥善保管您的账户信息，不得将账户信息透露给任何第三方。对于因您的疏忽导致的账户安全问题，本平台不承担责任。
	      <div class="hei20"></div>
	    三、数据安全<br/>
	    1. 数据保护：本平台承诺采取行业标准的安全措施保护您的个人数据不被非法使用或泄露。<br/>
	    2. 数据使用：<span style="font-weight: 550;">您同意并授权本平台按照相关法律法规和本协议的规定使用您的个人信息。</span><br/>
	    3. 数据泄露：如发生数据泄露事件，本平台将立即采取补救措施，并在必要时通知您。<br/>
	      <div class="hei20"></div>
	    四、服务使用<br/>
	    1. 合法使用：您同意仅将本平台用于合法目的，并遵守所有相关法律法规。<br/>
	    2. 禁止行为：您不得利用本平台进行任何违法活动，包括但不限于侵犯他人知识产权、传播非法内容、进行欺诈行为等。<br/>
	    3. 用户行为：您应尊重其他用户的权利，不得进行任何形式的骚扰、诽谤或侵犯他人隐私的行为。<br/>
	      <div class="hei20"></div>
	    五、版权声明<br/>
	    1. 版权所有：本平台内所有内容，包括但不限于文本、图片、视频、音频、软件等，均受版权保护。<br/>
	    2. 版权使用：未经本平台或版权所有者的明确书面授权，您不得复制、修改、传播、展示或以其他方式使用本平台的任何内容。<br/>
	    3. 用户内容：您上传至本平台的所有内容，视为您授权本平台在必要时使用、复制、修改、传播等，但本平台不会用于商业目的。<br/>
	      <div class="hei20"></div>
	    六、免责声明<br/>
	    1. 服务提供：本平台提供的服务是“现状”提供的，我们不提供任何形式的保证，包括但不限于适销性、适用性、无侵权等保证。<br/>
	    2.损害赔偿：<span style="font-weight: 550;">对于因使用本平台服务导致的任何直接、间接、偶然、特殊或后果性的损害，本平台不承担责任。<br/>
	    3. 第三方服务：本平台不对任何第三方服务或内容承担责任，您应自行判断并承担使用第三方服务的风险。</span><br/>
	      <div class="hei20"></div>
	    七、争议解决<br/>
	    1. 适用法律：本协议的解释、适用及争议解决均适用中华人民共和国法律。<br/>
	    2. 争议解决：如发生任何与本协议有关的争议，双方应首先通过友好协商解决；协商不成时，任何一方均可向本平台所在地的人民法院提起诉讼。<br/>
	      <div class="hei20"></div>
	   八、其他<br/>
	   1.协议完整性：本协议构成双方关于本平台服务的全部协议，并取代之前的所有口头或书面协议。<br/>
	   2. 条款独立性：如本协议的任何条款被认定为无效或不可执行，不影响其他条款的有效性。<br/>
	   3. 通知方式：本平台可以通过平台公告、电子邮件、短信等方式向您发送通知。用户应确保提供的联系方式准确无误，并在变更时及时更新，以确保能够接收到相关通知，否则自行承担一切不利后果。<br/>
	      <div class="hei20"></div>
	    九、协议生效<br/>
	    本协议自您点击“同意”按钮并完成注册流程之日起生效。<br/>
	      <div class="hei20"></div>
	  	<div class="hei20"></div>
	    
	    <div class="read_r">四川数字出版传媒有限公司平台</div>
	    <div class="read_r">2024年9月9日</div>
	  
	    <template #footer>
	      <div class="dialog-footer">
	        <el-button @click="agreeToTerms()" type="primary">我已阅读并同意用户协议</el-button> 
	      </div>
	    </template>
	  </el-dialog>
</template>

<script>
import Footer from '@/components/Footer'
import Header from '@/components/HeaDer'
import request from "@/utils/request";

export default{
  components: { 
    Footer: Footer,
	Header,
  },
  data() {
    return {
      idCard: '',
      name: '',
      password: '',
      confirmPassword: '',
      touchIdCard: false,
      touchName: false,
      touchPassword: false,
      touchConfirm: false,
      isSubmitting: false,
      submitError: '',
      agree: false,
	  centerDialogVisible: false,
	  showclose: false,
	  scrollTop: 0,
    }
  },
  watch: {
    centerDialogVisible(newVal) {
      if (newVal) {
        // 弹框打开时，添加类名并禁用滚动
        document.body.classList.add('dialog-open');
        this.saveScrollPosition();
        this.disableScroll();
      } else {
        // 弹框关闭时，移除类名并恢复滚动
        document.body.classList.remove('dialog-open');
        this.enableScroll();
        this.restoreScrollPosition();
      }
    }
  },
  computed: {
    idCardError() {
      if (!this.idCard) return '请输入身份证号';
      const idCardRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return idCardRegex.test(this.idCard) ? '' : '身份证号格式不正确';
    },
    nameError() {
      if (!this.name) return '请输入姓名';
      const nameRegex = /^[\u4e00-\u9fa5]{2,10}$/;
      return nameRegex.test(this.name) ? '' : '请输入2-10位的中文姓名';
    },
    passwordError() {
      if (!this.password) return '请输入密码';
      const pwdRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/;
      return pwdRegex.test(this.password) ? '' : '请输入>=8并且<=20位的密码，包含数字、字母';
    },
    confirmPasswordError() {
      if (!this.confirmPassword) return '请再次输入密码';
      return this.confirmPassword === this.password ? '' : '两次输入的密码不一致';
    },
    isFormValid() {
      return this.idCardError === '' && this.nameError === '' && this.passwordError === '' && this.confirmPasswordError === '';
    }
  },
  methods: {
    async onSubmit() {
      this.touchIdCard = true;
      this.touchName = true;
      this.touchPassword = true;
      this.touchConfirm = true;
      this.submitError = '';
      if (!this.isFormValid || this.isSubmitting || !this.agree) return;
      this.isSubmitting = true;
      try {
        console.log('发送注册请求:', {
          num: this.idCard,
          name: this.name,
          password: this.password
        });
        
        const res = await request.post('dtb/v1/user/gw_create', {
          num: this.idCard,
          name: this.name,
          password: this.password
        });
        
        console.log('注册成功:', res);
        // 根据返回结构处理成功逻辑
        this.$router.push('/Login');
      } catch (e) {
        console.error('注册失败:', e);
        this.submitError = (e && e.message) ? e.message : '注册失败，请稍后重试';
      } finally {
        this.isSubmitting = false;
      }
    },
	showAgreement() {
		this.centerDialogVisible = true;
	},
	agreeToTerms() {
		this.agree = true;
		this.centerDialogVisible = false;
	}, 
	// 保存滚动位置
	saveScrollPosition() {
		this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	},
	// 禁用滚动
	disableScroll() {
		document.body.style.position = 'fixed';
		document.body.style.top = `-${this.scrollTop}px`;
		document.body.style.width = '100%';
		document.body.style.overflow = 'hidden';
	},
	// 启用滚动
	enableScroll() {
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.width = '';
		document.body.style.overflow = '';
	},
	// 恢复滚动位置
	restoreScrollPosition() {
		if (this.scrollTop !== undefined) {
			window.scrollTo(0, this.scrollTop);
		}
	}
  }
}
</script>

<style scoped>
body,html{
  width: 100%;
  overflow-x: hidden;
}
.login{
  width: 100%;
  margin-top: -100px;
}
.login_banner{
  width: 100%;
  height: 100vh;
  position: relative;
}
.login_banner img{
  width: 100%;
  height: 100%;
}
 .login_box{ 
	 width: 100%;
	 position: absolute;
	 top: 0;
	 left: 0; 
 }
 .form-wrap {
   width: 468px;
   padding-bottom: 60px;
   margin: 230px auto 0;
  background:url(../assets/img/loginminni_bg.png)no-repeat;
  background-size: 100% 100%;
    overflow: hidden;
 }
  .form-content {
      width: 400px;
      margin: 39px auto 0; 
  }
 .login-form {
  width: 100%;
   margin: 30px auto 0;
   display: flex;
   flex-direction: column;
 }
 .form-item {
   margin-bottom: 28px;
   display: flex;
   flex-direction: column;
 }
 ::v-deep .form-item input {
	 width: 86%;
       height: 45px;
       border-radius: 8px;
       border: 1px solid hsla(0,0%,40%,.35);
   padding: 0 6% 0 8%;  
   outline: none;
   background : none!important;
 }
 .error {
   color: #ff4d4f;
   font-size: 12px;
   margin-top: 6px;
 }
 .submit-btn {
   height: 44px;
   background: #409EFF;
   color: #fff;
   border: none;
   border-radius: 4px;
   cursor: pointer;
 }
 .submit-btn:disabled {
   background: #c0c4cc;
   cursor: not-allowed;
 }
  .form-wrap h6 {
      font-size: 22px;
      color: #3d3d3d; 
	  text-align: center;
  }
  .input-wrap {
    position: relative;
  }
  .input-wrap .icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.65;
    pointer-events: none;
  } 
  .input-wrap.id-card .icon {
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='2' y='4' width='20' height='16' rx='2' stroke='%23999' stroke-width='1.5'/%3E%3Cpath d='M8 8h8M8 12h8M8 16h4' stroke='%23999' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
  }
  .input-wrap.name .icon {
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='8' r='4' stroke='%23999' stroke-width='1.5'/%3E%3Cpath d='M5 20c0-3.314 3.134-6 7-6s7 2.686 7 6' stroke='%23999' stroke-width='1.5'/%3E%3C/svg%3E");
  }
  .input-wrap.lock .icon {
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='10' width='16' height='10' rx='2' stroke='%23999' stroke-width='1.5'/%3E%3Cpath d='M8 10V7a4 4 0 118 0v3' stroke='%23999' stroke-width='1.5' stroke-linecap='round'/%3E%3Ccircle cx='12' cy='15' r='1' fill='%23999'/%3E%3C/svg%3E");
  }

  .agree-row{
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #333;
    user-select: none;
  }
  .agree-row>input{
	  width: 16px!important ;
  }
  .agree-row span {
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
  }
  .agree-row span:hover {
    color: #66b1ff;
  }
  .register{
	  text-align: right;margin-top: 20px;
  }
  .hei20 {
    height: 20px;
  }
  .read_r {
    text-align: right;
    margin-top: 10px;
    color: #666;
  }
  .dialog-footer {
    text-align: center;
  }
  
  /* 防止弹框打开时页面抖动 */
  :deep(.el-dialog__wrapper) {
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  
  :deep(.el-dialog) {
    margin: 5vh auto !important;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  
  :deep(.el-dialog__body) {
    max-height: 60vh;
    overflow-y: auto;
    padding: 20px;
    flex: 1;
  }
  
  /* 防止页面内容跳动 */
  body.dialog-open {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
  }
@media screen and (max-width: 768px){
  .login_banner {
    width: 100%;
    height:100vh;
    position: relative;
  }
 .form-wrap {
     width: 96%;
     /* height: 560px; */
     padding-bottom: 60px;
     margin: 180px auto 0;
     background: url(data:image/png;base64,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)no-repeat;
     background-size: 100% 100%;
     overflow: hidden;
 }
 .form-wrap h6 {
     font-size: 18px;
     color: #3d3d3d;
     text-align: center;
 }
 .form-content {
     width: 100%;
     margin: 39px auto 0;
 }
 .login-form {
     width: 88%; 
 }
  .form-item input {
     width: 84%;  
     padding: 0 6% 0 10%; 
 }
 .register{
	 width: 92%;
 }
}

 
</style>
